module.exports = __webpack_public_path__ + "assets/c4a87cbd08b548193e6cddd02d0a9f0a.png";